import { useEffect, useEffectEvent, useRef } from 'react';

export const usePrevious = <T>(
  value: T,
  shouldUpdate?: (prev: T | undefined, next: T) => boolean
) => {
  const ref = useRef<T>(undefined);

  const updateRef = useEffectEvent((v: T) => {
    if (shouldUpdate ? shouldUpdate(ref.current, v) : true) {
      ref.current = v;
    }
  });
  useEffect(() => {
    updateRef(value);
  }, [value]);

  // eslint-disable-next-line react-hooks/refs
  return ref.current;
};
